'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Popover2 = require('material-ui/Popover');

var _Popover3 = _interopRequireDefault(_Popover2);

var _index = require('./styles/index');

var _index2 = _interopRequireDefault(_index);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WMPopover = function (_Popover) {
	_inherits(WMPopover, _Popover);

	function WMPopover() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, WMPopover);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WMPopover.__proto__ || Object.getPrototypeOf(WMPopover)).call.apply(_ref, [this].concat(args))), _this), _this.applyAutoPositionIfNeeded = function (anchor, target, targetOrigin, anchorOrigin, targetPosition) {
			var newTargetPosition = _get(WMPopover.prototype.__proto__ || Object.getPrototypeOf(WMPopover.prototype), 'applyAutoPositionIfNeeded', _this).call(_this, anchor, target, targetOrigin, anchorOrigin, targetPosition);

			// double-check whether we're off screen vertically and adjust
			if (newTargetPosition.top < 0 || newTargetPosition.top + target.bottom > window.innerHeight) {
				var newTop = targetPosition.top - (targetPosition.top + target.bottom - window.innerHeight);
				newTargetPosition.top = Math.max(0, newTop);
			}

			return newTargetPosition;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	return WMPopover;
}(_Popover3.default);

var WMToolTip = function WMToolTip(_ref2) {
	var anchorEl = _ref2.anchorEl,
	    anchorOrigin = _ref2.anchorOrigin,
	    canAutoPosition = _ref2.canAutoPosition,
	    id = _ref2.id,
	    open = _ref2.open,
	    targetOrigin = _ref2.targetOrigin,
	    children = _ref2.children,
	    zDepth = _ref2.zDepth,
	    style = _ref2.style;
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(
			WMPopover,
			{
				style: style || _index2.default.container,
				anchorEl: anchorEl,
				anchorOrigin: anchorOrigin,
				autoCloseWhenOffScreen: true,
				canAutoPosition: canAutoPosition,
				open: open,
				id: id,
				targetOrigin: targetOrigin,
				useLayerForClickAway: false,
				zDepth: zDepth
			},
			children
		)
	);
};

exports.default = WMToolTip;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMToolTip/index.js